import { useMutation } from "@apollo/react-hooks";
import { ChoiceList, Modal } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { MARK_MAPPING_ORDER_LABEL_SPLIT_TAG } from "../../../graphql/mutations";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";

export default function TiktokMarkSplitTag({
    open,
    onClose,
    ids,
    onCompleted,
}) {
    const [state, setState] = useReducer(reducerFn, {
        selected: ["no"],
    });

    const { setNotify, toggleToast } = useToastContext();

    const [setDelay] = useTimeout();
    const [markMappingOrderlabelSplit, { loading }] = useMutation(
        MARK_MAPPING_ORDER_LABEL_SPLIT_TAG,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Mark Order Label split success",
                    err: false,
                });

                onClose && onClose();
                setDelay(() => {
                    onCompleted && onCompleted();
                }, 2000);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        markMappingOrderlabelSplit({
            variables: {
                ids,
                isSplit:
                    state.selected?.length > 0 && state.selected[0] === "yes",
            },
        });
    }, [
        markMappingOrderlabelSplit,
        setNotify,
        toggleToast,
        ids,
        state.selected,
    ]);

    const handleStateChange = useCallback((selected) => {
        setState({ selected });
    }, []);

    return (
        <Modal
            title="Mark as Order Label Split"
            sectioned
            open={open}
            onClose={onClose}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <ChoiceList
                choices={[
                    { value: "no", label: "No" },
                    { value: "yes", label: "Yes" },
                ]}
                selected={state.selected}
                title="Is Order Label Split"
                onChange={handleStateChange}
            />
        </Modal>
    );
}
